<template>
  <div class="space-y-3">
    <p class="text-sm text-gray-600">Please provide the new primary garaging address.</p>
    <div>
      <label :for="`update-address-street-${_uid}`" class="block text-sm font-medium text-gray-700">Street Address <span class="text-red-500">*</span></label>
      <input 
        type="text" 
        :id="`update-address-street-${_uid}`" 
        :value="modelValue.street" 
        @input="updateDetail('street', $event.target.value)"
        class="input-responsive"
        required
        aria-describedby="update-address-street-error"
      />
      <p v-if="errors.street" :id="`update-address-street-error`" class="error-message">{{ errors.street }}</p>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div>
        <label :for="`update-address-city-${_uid}`" class="block text-sm font-medium text-gray-700">City <span class="text-red-500">*</span></label>
        <input 
          type="text" 
          :id="`update-address-city-${_uid}`" 
          :value="modelValue.city" 
          @input="updateDetail('city', $event.target.value)"
          class="input-responsive"
          required
          aria-describedby="update-address-city-error"
        />
         <p v-if="errors.city" :id="`update-address-city-error`" class="error-message">{{ errors.city }}</p>
      </div>
      <div>
        <label :for="`update-address-state-${_uid}`" class="block text-sm font-medium text-gray-700">State <span class="text-red-500">*</span></label>
        <input 
          type="text" 
          :id="`update-address-state-${_uid}`" 
          :value="modelValue.state"
          @input="updateDetail('state', $event.target.value)"
          placeholder="e.g., FL"
          class="input-responsive"
          required
          aria-describedby="update-address-state-error"
        />
         <p v-if="errors.state" :id="`update-address-state-error`" class="error-message">{{ errors.state }}</p>
      </div>
      <div>
        <label :for="`update-address-zip-${_uid}`" class="block text-sm font-medium text-gray-700">ZIP Code <span class="text-red-500">*</span></label>
        <input 
          type="text" 
          :id="`update-address-zip-${_uid}`" 
          :value="modelValue.zip"
          @input="updateDetail('zip', $event.target.value)"
          class="input-responsive"
          required
          aria-describedby="update-address-zip-error"
        />
         <p v-if="errors.zip" :id="`update-address-zip-error`" class="error-message">{{ errors.zip }}</p>
      </div>
    </div>
    
    <!-- Mailing Address Option -->
    <div class="pt-2">
      <div class="flex items-start">
        <input 
          type="checkbox" 
          :id="`update-address-same-${_uid}`" 
          :checked="modelValue.mailingSameAsGaraging"
          @change="updateDetail('mailingSameAsGaraging', $event.target.checked)"
          :class="props.customerType === 'customer' ? 'enhanced-checkbox-customer' : 'enhanced-checkbox'"
        />
        <label :for="`update-address-same-${_uid}`" class="ml-2 block text-sm text-gray-900">Mailing address is the same as the new garaging address.</label>
      </div>
    </div>

    <!-- Conditional Mailing Address Fields -->
    <div v-if="!modelValue.mailingSameAsGaraging" class="space-y-3 pt-3 border-t border-dashed mt-4">
      <p class="text-sm text-gray-600">Please provide the new mailing address.</p>
      <div>
        <label :for="`update-mail-street-${_uid}`" class="block text-sm font-medium text-gray-700">Mailing Street Address <span class="text-red-500">*</span></label>
        <input 
          type="text" 
          :id="`update-mail-street-${_uid}`" 
          :value="modelValue.mailingStreet"
          @input="updateDetail('mailingStreet', $event.target.value)"
          class="input-responsive"
          :required="!modelValue.mailingSameAsGaraging"
          aria-describedby="update-mail-street-error" 
        />
        <p v-if="errors.mailingStreet" :id="`update-mail-street-error`" class="error-message">{{ errors.mailingStreet }}</p>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div>
          <label :for="`update-mail-city-${_uid}`" class="block text-sm font-medium text-gray-700">Mailing City <span class="text-red-500">*</span></label>
          <input 
            type="text" 
            :id="`update-mail-city-${_uid}`" 
            :value="modelValue.mailingCity"
            @input="updateDetail('mailingCity', $event.target.value)"
            class="input-responsive"
            :required="!modelValue.mailingSameAsGaraging"
            aria-describedby="update-mail-city-error"
          />
           <p v-if="errors.mailingCity" :id="`update-mail-city-error`" class="error-message">{{ errors.mailingCity }}</p>
        </div>
        <div>
          <label :for="`update-mail-state-${_uid}`" class="block text-sm font-medium text-gray-700">Mailing State <span class="text-red-500">*</span></label>
          <input 
            type="text" 
            :id="`update-mail-state-${_uid}`" 
            :value="modelValue.mailingState"
            @input="updateDetail('mailingState', $event.target.value)"
            placeholder="e.g., FL"
            class="input-responsive"
             :required="!modelValue.mailingSameAsGaraging"
             aria-describedby="update-mail-state-error"
          />
           <p v-if="errors.mailingState" :id="`update-mail-state-error`" class="error-message">{{ errors.mailingState }}</p>
        </div>
        <div>
          <label :for="`update-mail-zip-${_uid}`" class="block text-sm font-medium text-gray-700">Mailing ZIP Code <span class="text-red-500">*</span></label>
          <input 
            type="text" 
            :id="`update-mail-zip-${_uid}`" 
            :value="modelValue.mailingZip"
            @input="updateDetail('mailingZip', $event.target.value)"
            class="input-responsive"
            :required="!modelValue.mailingSameAsGaraging"
             aria-describedby="update-mail-zip-error"
          />
           <p v-if="errors.mailingZip" :id="`update-mail-zip-error`" class="error-message">{{ errors.mailingZip }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { defineProps, defineEmits, getCurrentInstance } from 'vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';

const instance = getCurrentInstance();
const _uid = instance ? instance.uid : Math.random().toString(36).substring(7);

const props = defineProps({
  modelValue: { 
    type: Object,
    required: true,
    default: () => ({ 
        street: '', 
        city: '', 
        state: '', 
        zip: '', 
        mailingSameAsGaraging: true, 
        mailingStreet: '',
        mailingCity: '',
        mailingState: '',
        mailingZip: '' 
    }) 
  },
  customerType: {
    type: String,
    default: 'customer', // Or 'lender' depending on your most common use case
    validator: (value) => ['customer', 'lender'].includes(value)
  }
});

const emit = defineEmits(['update:modelValue']);

// --- Internal Validation Setup ---
const validationSchema = yup.object({
  street: yup.string().required('Street address is required'),
  city: yup.string().required('City is required'),
  state: yup.string().required('State is required'),
  zip: yup.string().required('ZIP code is required'),
  mailingSameAsGaraging: yup.boolean(),
  mailingStreet: yup.string().when('mailingSameAsGaraging', {
    is: false,
    then: (schema) => schema.required('Mailing street is required when different'),
    otherwise: (schema) => schema.nullable(),
  }),
  mailingCity: yup.string().when('mailingSameAsGaraging', {
    is: false,
    then: (schema) => schema.required('Mailing city is required when different'),
    otherwise: (schema) => schema.nullable(),
  }),
  mailingState: yup.string().when('mailingSameAsGaraging', {
    is: false,
    then: (schema) => schema.required('Mailing state is required when different'),
    otherwise: (schema) => schema.nullable(),
  }),
  mailingZip: yup.string().when('mailingSameAsGaraging', {
    is: false,
    then: (schema) => schema.required('Mailing ZIP is required when different'),
    otherwise: (schema) => schema.nullable(),
  }),
});

const { errors, validate: validateInternally, setErrors } = useForm({
  validationSchema: validationSchema,
  initialValues: props.modelValue
});

const updateDetail = (key, value) => {
  const newValue = { 
    ...props.modelValue, 
    [key]: value 
  };
  // If checking same as mailing, clear mailing fields
  if (key === 'mailingSameAsGaraging' && value === true) {
      newValue.mailingStreet = '';
      newValue.mailingCity = '';
      newValue.mailingState = '';
      newValue.mailingZip = '';
      // Also clear potential errors for mailing fields
      errors.value.mailingStreet = undefined;
      errors.value.mailingCity = undefined;
      errors.value.mailingState = undefined;
      errors.value.mailingZip = undefined;
  }
  emit('update:modelValue', newValue);
};

// --- Expose validation function to parent ---
defineExpose({
  validate() {
    let isValid = true;
    const currentErrors = {};

    // Perform primary synchronous checks for garaging address fields
    if (!props.modelValue.street || !props.modelValue.street.trim()) {
      isValid = false;
      currentErrors.street = 'Street address is required';
    }
    if (!props.modelValue.city || !props.modelValue.city.trim()) {
      isValid = false;
      currentErrors.city = 'City is required';
    }
    if (!props.modelValue.state || !props.modelValue.state.trim()) {
      isValid = false;
      currentErrors.state = 'State is required';
    }
    if (!props.modelValue.zip || !props.modelValue.zip.trim()) {
      isValid = false;
      currentErrors.zip = 'ZIP code is required';
    }

    // Perform synchronous checks for mailing address fields if applicable
    if (!props.modelValue.mailingSameAsGaraging) {
      if (!props.modelValue.mailingStreet || !props.modelValue.mailingStreet.trim()) {
        isValid = false;
        currentErrors.mailingStreet = 'Mailing street is required when different';
      }
      if (!props.modelValue.mailingCity || !props.modelValue.mailingCity.trim()) {
        isValid = false;
        currentErrors.mailingCity = 'Mailing city is required when different';
      }
      if (!props.modelValue.mailingState || !props.modelValue.mailingState.trim()) {
        isValid = false;
        currentErrors.mailingState = 'Mailing state is required when different';
      }
      if (!props.modelValue.mailingZip || !props.modelValue.mailingZip.trim()) {
        isValid = false;
        currentErrors.mailingZip = 'Mailing ZIP is required when different';
      }
    }

    // Trigger VeeValidate's internal validation
    validateInternally({ force: true });

    // If our direct synchronous checks already failed, return false.
    if (!isValid) {
      setErrors({
        ...errors.value, // Preserve other errors VeeV might have set
        ...currentErrors 
      });
      return false;
    }

    // After triggering VeeValidate and passing initial synchronous checks,
    // check the reactive 'errors' object for any errors VeeValidate might have found.
    return Object.keys(errors.value).length === 0;
  }
});
</script>

<style scoped>
.input-responsive {
    @apply mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm;
}

.error-message {
    @apply text-red-500 text-xs italic mt-1;
}
</style> 